import React from 'react';
import { classNameBuilder } from '../../utils/className';

import './Typography.scss';

export type TypographyVariant = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h-48' | 'p';
interface IProps {
    variant?: TypographyVariant;
    color?: 'white' | 'cyan' | 'blue' | 'green' | 'black' | 'grey' | 'default';
    size?: string;
    className?: string;
    wordBreak?: boolean;
    children: React.ReactNode | string;
}

const Typography: React.FC<IProps> = ({
    variant = 'p',
    children,
    color = 'default',
    size = '16px',
    className,
    wordBreak = false,
}) => {
    const cn = classNameBuilder('typography');
    const mod = { type: variant, color: color, wordBreak: wordBreak };

    switch (variant) {
        case 'h1':
            return <h1 className={`${cn(mod)} ${className}`}>{children}</h1>;
        case 'h2':
            return <h2 className={`${cn(mod)} ${className}`}>{children}</h2>;
        case 'h-48':
            return <h2 className={`${cn(mod)} ${className}`}>{children}</h2>;
        case 'h3':
            return <h3 className={`${cn(mod)} ${className}`}>{children}</h3>;
        case 'h4':
            return <h4 className={`${cn(mod)} ${className}`}>{children}</h4>;
        case 'h5':
            return <h4 className={`${cn(mod)} ${className}`}>{children}</h4>;
        default:
            return (
                <p className={`${cn(mod)} ${className}`} style={{ fontSize: size }}>
                    {children}
                </p>
            );
    }
};

export default Typography;
